import React from "react"
import {
    CssBaseline,
    Grid,
    useMediaQuery, useTheme
} from "@mui/material";
import CustomNavbar from "../components/CustomNavbar";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import InfoPageCityLayout from "../layouts/info/InfoPageCityLayout";
import InfoPageTreeLayout from "../layouts/info/InfoPageTreeLayout";
import InfoPageSoilSealingLayout from "../layouts/info/InfoPageSoilSealingLayout";
import InfoPageSoilTypeLayout from "../layouts/info/InfoPageSoilTypeLayout";
import InfoPageSkyViewFactorLayout from "../layouts/info/InfoPageSkyViewFactorLayout";
import BackButton from "../components/BackButton";
import Footer from "../components/Footer";
import InfoPageTreeSizeLayout from "../layouts/info/InfoPageTreeSizeLayout";
import NotFoundLayout from "../layouts/common/NotFoundLayout";
import LeftNavigation from "../components/LeftNavigation";
import InfoPagePeriodLayout from "../layouts/info/InfoPagePeriodLayout";
import RightLogo from "../components/RightLogo";
import {getCurrentLanguage} from "../utils/Helpers";


const InfoPage = () => {
    const {t,i18n} = useTranslation()
    const theme = useTheme();
    const navigate = useNavigate();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const [searchParams] = useSearchParams();
    let key = getCurrentLanguage(i18n);
    const onBack = () =>{
        navigate("/simulation")
    }

    const createLayout = () => {
        switch (searchParams.get("type")) {
            case "city":
                return <InfoPageCityLayout language={key} smScreen={smScreen}/>
            case "tree":
                return <InfoPageTreeLayout language={key}/>
            case "tree_size":
                return <InfoPageTreeSizeLayout/>
            case "soil_type":
                return <InfoPageSoilTypeLayout/>
            case "soil_sealing":
                return <InfoPageSoilSealingLayout/>
            case "sky_view_factor":
                return <InfoPageSkyViewFactorLayout/>
            case "period":
                return <InfoPagePeriodLayout/>
            default:
                return <NotFoundLayout/>
        }
    }
    return (
        <React.Fragment>
            <CssBaseline/>
            <CustomNavbar/>
            <React.Fragment>
                <BackButton onClick={onBack}/>
                <Grid container>
                    <Grid item xs={2}>
                        <LeftNavigation t={t}/>
                    </Grid>
                    <Grid item xs={8} sx={{paddingLeft:8, paddingRight: 8}}>
                        {
                            createLayout()
                        }
                    </Grid>
                    <Grid item xs={2}>
                        <RightLogo/>
                    </Grid>
                </Grid>
            </React.Fragment>
            <Footer/>
        </React.Fragment>
    )
}
export default InfoPage
